var path = 'areas/shared/views/selector/choice-tag.html';
var html = "<span class=\"label label-info\" ng-style=\"{ 'background-color' : item.Color }\" ng-bind-html=\"item.Name | highlight: $select.search\"></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/choice-tag.html
// module id = 1343962954037803
// module chunks = 1